module.exports = __webpack_public_path__ + "static/media/simplilearn-01.d2641629.png";